module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Category\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs--default"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "name": "category",
      "id": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.categoryList), function(item) {
    return _c('option', {
      domProps: {
        "value": item,
        "selected": item == _vm.category ? 'true' : 'false'
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Name\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs--default"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentName),
      expression: "documentName"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "name",
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.documentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.documentName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Order By\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs--default"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderBy),
      expression: "orderBy"
    }],
    attrs: {
      "name": "orderBy",
      "id": "orderBy"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v("Ascending")]), _vm._v("Document Type\n                    "), _c('option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v("Descending")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3 u-align-self-flex-end u-r-align-self-flex-start"
  }, [_c('button', {
    staticClass: "a-button a-button--small a-button--no-margin",
    on: {
      "click": _vm.documentSearch
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "a-loader--documents"
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "flex-grid p-resources-and-tools__documents"
  }, [_vm._l((_vm.documents), function(document) {
    return _c('div', {
      staticClass: "p-resources-and-tools__document"
    }, [_c('div', {
      staticClass: "p-resources-and-tools__document-image"
    }, [_c('a', {
      attrs: {
        "href": document['link'] + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": document['thumbnail_src'] + '?access_token=' + _vm.getToken,
        "alt": document['name']
      }
    })])]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": document['link'] + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(document['name']))]), _vm._v(" "), (document['published_date']) ? _c('span', [_vm._v("Published at: " + _vm._s(document['published_date']))]) : _vm._e()])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.documents.length),
      expression: "!documents.length"
    }]
  }, [_vm._v("Documents will return shortly.")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58f6adf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources-and-tools/Documents.vue
// module id = 1704
// module chunks = 0